export const getTenantId = (tenant: string) => {
  switch (tenant) {
    case 'sollentuna':
      return process.env.REACT_APP_CLIENT_ID_SOLLENTUNA
    case 'jonkoping':
      return process.env.REACT_APP_CLIENT_ID_JONKOPING
    case 'norrkoping':
      return process.env.REACT_APP_CLIENT_ID_NORRKOPING
    case 'hultsfred':
      return process.env.REACT_APP_CLIENT_ID_HULTSFRED
    case 'sala':
      return process.env.REACT_APP_CLIENT_ID_SALA
    case 'kalmar':
      return process.env.REACT_APP_CLIENT_ID_KALMAR
    case 'vasteras':
      return process.env.REACT_APP_CLIENT_ID_VASTERAS
    case 'taby':
      return process.env.REACT_APP_CLIENT_ID_TABY
    case 'dev':
      return process.env.REACT_APP_CLIENT_ID_DEV
    case 'demo':
      return process.env.REACT_APP_CLIENT_ID_DEMO
    default:
      throw new Error('Error in kommun')
  }
}
